/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { constants } from '../../modules/utils/constants';

const MemberSnapshotRibbon = dynamic(() => import('./MemberSnapshotRibbon').then(mod => mod.MemberSnapshotRibbon));
const MemberSnapshotRibbonV2 = dynamic(() =>
  import('./MemberSnapshotRibbonV2').then(mod => mod.MemberSnapshotRibbonV2)
);

export const MemberSnapshotRibbonConfig = {
  emptyLabel: 'MemberSnapshotRibbon',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/membersnapshotribbon`,
};

export const MemberSnapshotRibbonEditable = (props: any) => (
  <EditableComponent config={MemberSnapshotRibbonConfig} {...props}>
    {props?.model?.variation === constants.VARIATION_2 ? (
      <MemberSnapshotRibbonV2 {...props} />
    ) : (
      <MemberSnapshotRibbon {...props} />
    )}
  </EditableComponent>
);
